// Hook odpowiedzialny za pobranie popularnych artykułów z bazy wiedzy

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';
import { IKnowledgeBaseArticle } from 'api/endpoints/useGetKnowledgeBaseArticles';

// parametry requestu do api
export type IRequest = IPaginationRequest & {
  sort_by?: 'created_at' | 'updated_at';
  sort_order?: 'asc' | 'desc';
};

// typ zwracanych danych
type IResponse = IPaginationResponse<IKnowledgeBaseArticle>;

const getKnowledgeBasePopularArticles = (params?: IRequest): Promise<IResponse> =>
  axios.get('/cms/knowledge-base/articles_popular', { params });

export const useGetKnowledgeBasePopularArticles = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['knowledge-base-popular-articles', params],
    () => getKnowledgeBasePopularArticles(params),
    options
  );

